import { createContext, useContext, useEffect, useState } from "react";
import { adminApi, TOKEN_KEY } from "@/admin/api";

const Ctx = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=anon, object=authed
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    if (!localStorage.getItem(TOKEN_KEY)) { setUser(false); setLoading(false); return; }
    try {
      const { data } = await adminApi.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
      localStorage.removeItem(TOKEN_KEY);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await adminApi.post("/auth/logout"); } catch {}
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };

  return (
    <Ctx.Provider value={{ user, setUser, loading, login, logout, refresh }}>
      {children}
    </Ctx.Provider>
  );
};

export const useAdminAuth = () => useContext(Ctx);
